import { useEffect } from "react";
import { ContainerV2, H1, P } from "../../Atoms";
import { FormVehicleRegisterV2 } from "../../Molecules/FormVehicleRegisterV2";
import { Tracking } from "../../../services/Tracking";
import { useVehicleRegisterV2 } from "./useVehicleRegisterV2";

export const VehicleRegisterV2 = () => {
  const { stepIndicator, handleSubmit } = useVehicleRegisterV2();

  useEffect(() => {
    Tracking.pageView("mapa:agendamento/servicos/primeiro-registro:pageview");
  });

  return (
    <ContainerV2 nextButton={{ title: "Avançar", disabled: true }}>
      {stepIndicator}
      <H1 className="mb-4 mt-8">Identifique o veículo</H1>
      <P className="mb-6 text-[#666666]">
        Consultamos as informações automaticamente. Você só precisa confirmar.
      </P>

      <FormVehicleRegisterV2 onSubmitForm={handleSubmit} />
    </ContainerV2>
  );
};
